module.exports = __webpack_public_path__ + "static/img/wealth_level_61.18e4a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_61.png
// module id = oOZm
// module chunks = 0